module.exports = __webpack_public_path__ + "assets/img/10_2_big.9987da7b.jpg";